export default [
  {
    title: '膠原蛋白酵素SPA',
    name: 'jiao-yuan-dan-bai-jiao-su-spa',
    to: {
      name: 'spa',
      params: {
        spaAlias: 'jiao-yuan-dan-bai-jiao-su-spa'
      }
    },
    description: '（犬貓適用）使用Hyponic 100%天然低敏洗淨成分，食品等級基底以木瓜酵素、花粉萃取精華做去角質，調理肌膚油脂分泌，膠原蛋白、仙人掌萃取精華使皮毛保有天然亮麗光澤，將SPA時間達到精簡無負擔的效果，適合初步體驗SPA或是較易緊張的毛孩，針對毛髮和皮膚的去角質，改善皮屑和出油部位，並適當滋潤的油脂平衡。',
    period: '5',
    minPrice: 350,
    maxPrice: 500,
    effect: '保濕去角質、肌膚調理',
    images: [
      require("@assets/images/jtails/SPA/2@2.jpg"),
      require("@assets/images/jtails/SPA/3@2.jpg"),
      require("@assets/images/jtails/SPA/1@2.jpg"),
    ],
    catInfo: [
      {
        title: '短毛貓',
        bodyType: '短毛貓',
        price: '400',
      },
      {
        title: '長毛貓',
        bodyType: '長毛貓',
        price: '400',
      }
    ],
    dogInfo: [
      {
        title: '迷你型',
        bodyType: '3kg 以下',
        price: '350',
      },
      {
        title: '小型',
        bodyType: '3-5kg',
        price: '350',
      },
      {
        title: '中小型',
        bodyType: '6-10kg',
        price: '400',
      },
      {
        title: '中型',
        bodyType: '11-16kg',
        price: '400',
      },
      {
        title: '中大型',
        bodyType: '17-22kg',
        price: '450',
      },
      {
        title: '大型',
        bodyType: '23-27kg',
        price: '450',
      },
      {
        title: '特大型',
        bodyType: '28-33kg',
        price: '500',
      },
    ],
    catTip: '',
  },
  {
    title: '頂級純氧牛奶SPA',
    name: 'ding-ji-chun-yang-niou-nai-spa',
    to: {
      name: 'spa',
      params: {
        spaAlias: 'ding-ji-chun-yang-niou-nai-spa'
      }
    },
    description: '（犬貓適用）小捲尾的招牌美容牛奶SPA，MMB頂級磁化能量牛奶浴， 以磁化能量牛奶氣泡泉浴缸進行SPA浴程，打出極為細小的氣泡呈現乳白色而獲其美名為牛奶浴，深入毛孔深層清潔老廢角質、代謝廢毛、改善缺毛和緩解過敏性皮膚搔癢暗紅、以超高負離子群增強免疫力和增加皮膚及毛髮的需氧量，並促進新陳代謝、血液循環，為毛髮提供足夠的保濕度、光澤度、和柔順度，並搭配水療按摩進行皮膚調理和護膚，定期每週使用效果更佳。',
    period: '15',
    minPrice: 350,
    maxPrice: 500,
    effect: '代謝廢毛、護膚緩敏',
    images: [
      require("@assets/images/jtails/SPA/2@2.jpg"),
      require("@assets/images/jtails/SPA/3@2.jpg"),
      require("@assets/images/jtails/SPA/1@2.jpg"),
    ],
    catInfo: [
      {
        title: '短毛貓',
        bodyType: '短毛貓',
        price: '400',
      },
      {
        title: '長毛貓',
        bodyType: '長毛貓',
        price: '400',
      }
    ],
    dogInfo: [
      {
        title: '迷你型',
        bodyType: '3kg 以下',
        price: '350',
      },
      {
        title: '小型',
        bodyType: '3-5kg',
        price: '350',
      },
      {
        title: '中小型',
        bodyType: '6-10kg',
        price: '400',
      },
      {
        title: '中型',
        bodyType: '11-16kg',
        price: '400',
      },
      {
        title: '中大型',
        bodyType: '17-22kg',
        price: '450',
      },
      {
        title: '大型',
        bodyType: '23-27kg',
        price: '450',
      },
      {
        title: '特大型',
        bodyType: '28-33kg',
        price: '500',
      },
    ],
    catTip: '',
  },
  {
    title: '貴族藍泥面膜SPA',
    name: 'guei-zu-lan-ni-mian-mo-spa',
    to: {
      name: 'spa',
      params: {
        spaAlias: 'guei-zu-lan-ni-mian-mo-spa',
      }
    },
    description: '使用英國倫敦Ｗild Wash 有機認證精油SPA系列，以有機乳油木果​作為保濕和調理​​，​金盞花滋潤提亮皮膚​，​以及梔子提供天然美白為主要特性，​將​呈現藍灰色的泥膜塗抹至面部配合按摩後再塗抹第二道靜敷，蘊含豐富微量元素及礦物質透過高嶺土吸附毛孔雜質有效幫助狗狗的臉部角質代謝和提亮。',
    period: '10',
    minPrice: 350,
    maxPrice: 500,
    effect: '淚腺調理、臉部去角質',
    images: [
      require("@assets/images/jtails/SPA/1@2.jpg"),
      require("@assets/images/jtails/SPA/2@2.jpg"),
      require("@assets/images/jtails/SPA/3@2.jpg"),
    ],
    catInfo: [],
    dogInfo: [
      {
        title: '迷你型',
        bodyType: '3kg 以下',
        price: '350',
      },
      {
        title: '小型',
        bodyType: '3-5kg',
        price: '350',
      },
      {
        title: '中小型',
        bodyType: '6-10kg',
        price: '400',
      },
      {
        title: '中型',
        bodyType: '11-16kg',
        price: '400',
      },
      {
        title: '中大型',
        bodyType: '17-22kg',
        price: '450',
      },
      {
        title: '大型',
        bodyType: '23-27kg',
        price: '450',
      },
      {
        title: '特大型',
        bodyType: '28-33kg',
        price: '500',
      },
    ],
    catTip: '此SPA所含精油成份貓咪不適用',
  },
  {
    title: '天然檜木泡澡露SPA',
    name: 'tian-ran-guei-mu-pao-zao-lou-spa',
    to: {
      name: 'spa',
      params: {
        spaAlias: 'tian-ran-guei-mu-pao-zao-lou-spa',
      }
    },
    description: '（犬貓適用）以日本專利蒸餾技術緩蒸慢餾而成的精華露，具美毛、消臭、深層清潔、抑菌及隔離害蟲之效用。全犬貓種及各式家庭寵物皆適用，舔食無礙、定期泡澡可使毛皮保濕、柔順及同時修護毛髮，維持毛髮亮麗光澤，營造健全之毛皮環境免於害蟲侵襲。適用於減緩舒壓用，毛皮油膩異味濃厚時，外出沾染髒汙後，游泳後，害蟲繁殖季，毛皮乾澀時－搭配浴缸泡澡做使用。',
    period: '10',
    minPrice: 300,
    maxPrice: 500,
    effect: '深層潔淨、抑菌保濕',
    images: [
      require("@assets/images/jtails/SPA/1@2.jpg"),
      require("@assets/images/jtails/SPA/2@2.jpg"),
      require("@assets/images/jtails/SPA/3@2.jpg"),
    ],
    catInfo: [
      {
        title: '短毛貓',
        bodyType: '短毛貓',
        price: '400',
      },
      {
        title: '長毛貓',
        bodyType: '長毛貓',
        price: '400',
      }
    ],
    dogInfo: [
      {
        title: '迷你型',
        bodyType: '3kg 以下',
        price: '350',
      },
      {
        title: '小型',
        bodyType: '3-5kg',
        price: '350',
      },
      {
        title: '中小型',
        bodyType: '6-10kg',
        price: '400',
      },
      {
        title: '中型',
        bodyType: '11-16kg',
        price: '400',
      },
      {
        title: '中大型',
        bodyType: '17-22kg',
        price: '450',
      },
      {
        title: '大型',
        bodyType: '23-27kg',
        price: '450',
      },
      {
        title: '特大型',
        bodyType: '28-33kg',
        price: '500',
      },
    ],
    catTip: '',
  },
  {
    title: '法國玫瑰活膚泥SPA',
    name: 'fa-guo-mei-guei-huo-fu-ni-spa',
    to: {
      name: 'spa',
      params: {
        spaAlias: 'fa-guo-mei-guei-huo-fu-ni-spa',
      }
    },
    description: '（犬貓適用）以法國玫瑰泥、金盞花萃取物、酪梨油為主要成分，透過靜敷並按摩進肌膚，幫助吸收皮膚濕氣及油脂、舒緩皮膚敏感、搔癢，收斂維持皮膚乾爽為皮膚形成一道天然保護膜，法國玫瑰泥呈現淡淡的粉色質地，是功效兼具療癒感的頂級皮膚調理保養SPA之一。',
    period: '10',
    minPrice: 600,
    maxPrice: 2200,
    effect: '緩敏去濕、皮毛保護',
    images: [
      require("@assets/images/jtails/SPA/1@2.jpg"),
      require("@assets/images/jtails/SPA/2@2.jpg"),
      require("@assets/images/jtails/SPA/3@2.jpg"),
    ],
    catInfo: [
      {
        title: '短毛貓',
        bodyType: '短毛貓',
        price: '700',
      },
      {
        title: '長毛貓',
        bodyType: '長毛貓',
        price: '750',
      }
    ],
    dogInfo: [
      {
        title: '迷你型',
        bodyType: '3kg 以下',
        price: '600',
      },
      {
        title: '小型',
        bodyType: '3-5kg',
        price: '700',
      },
      {
        title: '中小型',
        bodyType: '6-10kg',
        price: '850',
      },
      {
        title: '中型',
        bodyType: '11-16kg',
        price: '1100',
      },
      {
        title: '中大型',
        bodyType: '17-22kg',
        price: '1400',
      },
      {
        title: '大型',
        bodyType: '23-27kg',
        price: '1950',
      },
      {
        title: '特大型',
        bodyType: '28-33kg',
        price: '2200',
      },
    ],
    catTip: '',
  },
  {
    title: '冰河淨膚排毛泥SPA',
    name: 'bing-he-jing-fu-pai-mao-ni-spa',
    to: {
      name: 'spa',
      params: {
        spaAlias: 'bing-he-jing-fu-pai-mao-ni-spa',
      }
    },
    description: '（犬貓適用）以加拿大冰河泥、瓜拿納(巴西香可可)、有機蘆薈為主要成分，透過靜敷並按摩進肌膚，幫助加速廢毛排除，調節皮脂分泌去除異味，減緩蚤蝨叮咬後的癢感，非常適用於換毛季節的敏感肌膚，為皮膚形成一道天然保護膜，是非常有感的頂級皮膚調理保養SPA之一。',
    period: '10',
    minPrice: 600,
    maxPrice: 2200,
    effect: '排除廢毛、調節皮脂',
    images: [
      require("@assets/images/jtails/SPA/1@2.jpg"),
      require("@assets/images/jtails/SPA/2@2.jpg"),
      require("@assets/images/jtails/SPA/3@2.jpg"),
    ],
    catInfo: [
      {
        title: '短毛貓',
        bodyType: '短毛貓',
        price: '700',
      },
      {
        title: '長毛貓',
        bodyType: '長毛貓',
        price: '750',
      }
    ],
    dogInfo: [
      {
        title: '迷你型',
        bodyType: '3kg 以下',
        price: '600',
      },
      {
        title: '小型',
        bodyType: '3-5kg',
        price: '700',
      },
      {
        title: '中小型',
        bodyType: '6-10kg',
        price: '850',
      },
      {
        title: '中型',
        bodyType: '11-16kg',
        price: '1100',
      },
      {
        title: '中大型',
        bodyType: '17-22kg',
        price: '1400',
      },
      {
        title: '大型',
        bodyType: '23-27kg',
        price: '1950',
      },
      {
        title: '特大型',
        bodyType: '28-33kg',
        price: '2200',
      },
    ],
    catTip: '',
  },
  {
    title: '阿育吠陀有機草本泥SPA',
    name: 'a-yo-fei-tuo-you-ji-cao-ben-ni-spa',
    to: {
      name: 'spa',
      params: {
        spaAlias: 'a-yo-fei-tuo-you-ji-cao-ben-ni-spa',
      }
    },
    description: '（犬貓適用）使用Mad Farmers 100%植物系寵物品牌,100%有機苦楝葉草本泥，食用等級的有機阿育吠陀草本泥，透過按摩和靜敷代謝污垢和廢毛，可以鎮定肌膚、抗菌防蟲、併透過天然茶粉的香味幫助放鬆心靈，同時調理油脂分泌並將水份鎖進肌膚護膚潤毛，是時下最收歡迎的頂級皮膚調理保養SPA。',
    period: '15',
    minPrice: 600,
    maxPrice: 2200,
    effect: '抗菌防蟲、鎮定肌膚',
    images: [
      require("@assets/images/jtails/SPA/1@2.jpg"),
      require("@assets/images/jtails/SPA/2@2.jpg"),
      require("@assets/images/jtails/SPA/3@2.jpg"),
    ],
    catInfo: [
      {
        title: '短毛貓',
        bodyType: '短毛貓',
        price: '700',
      },
      {
        title: '長毛貓',
        bodyType: '長毛貓',
        price: '750',
      }
    ],
    dogInfo: [
      {
        title: '迷你型',
        bodyType: '3kg 以下',
        price: '600',
      },
      {
        title: '小型',
        bodyType: '3-5kg',
        price: '700',
      },
      {
        title: '中小型',
        bodyType: '6-10kg',
        price: '850',
      },
      {
        title: '中型',
        bodyType: '11-16kg',
        price: '1100',
      },
      {
        title: '中大型',
        bodyType: '17-22kg',
        price: '1400',
      },
      {
        title: '大型',
        bodyType: '23-27kg',
        price: '1950',
      },
      {
        title: '特大型',
        bodyType: '28-33kg',
        price: '2200',
      },
    ],
    catTip: '',
  },
]
